export function thumbnail(videoId: string, res: 'sd' | 'mq' | 'hq' | 'maxres' = 'sd') {
    return `https://img.youtube.com/vi/${videoId}/${res}default.jpg`
}

export function embeddedSrc(videoId: string) {
    return `https://www.youtube.com/embed/${videoId}`
}